import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
  class: "order-checkout"
};
const _hoisted_2 = {
  class: "main-wrap"
};
const _hoisted_3 = {
  class: "header-bar"
};
const _hoisted_4 = {
  class: "driver-status",
  style: {
    "display": "none"
  }
};
const _hoisted_5 = {
  key: 0,
  class: "distance-you"
};
const _hoisted_6 = {
  class: "mapContainer"
};
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  id: "map"
}, null, -1);
const _hoisted_8 = {
  class: "map-button"
};
const _hoisted_9 = {
  key: 0,
  class: "button left-button"
};
const _hoisted_10 = {
  class: "bottom-wrap"
};
const _hoisted_11 = {
  class: "bottom-main checkout-wrap"
};
const _hoisted_12 = {
  class: "card-bold card-bg order-status"
};
const _hoisted_13 = {
  class: "status-layout"
};
const _hoisted_14 = {
  class: "status"
};
const _hoisted_15 = {
  class: "remind"
};
const _hoisted_16 = {
  class: "order-flag"
};
const _hoisted_17 = {
  class: "vehicle-data"
};
const _hoisted_18 = {
  class: "plate-number"
};
const _hoisted_19 = {
  key: 0,
  class: "vehicle-attr"
};
const _hoisted_20 = {
  class: "driver-info"
};
const _hoisted_21 = {
  class: "name"
};
const _hoisted_22 = {
  key: 0,
  class: "star-rating"
};
const _hoisted_23 = {
  key: 1,
  class: "order-count"
};
const _hoisted_24 = {
  class: "vehicle-thumbnail"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = {
  key: 0,
  class: "operate"
};
const _hoisted_27 = {
  key: 0,
  class: "route-info arrive"
};
const _hoisted_28 = {
  class: "left"
};
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot start-dot"
}, null, -1);
const _hoisted_30 = {
  class: "address"
};
const _hoisted_31 = {
  class: "right"
};
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", {
  class: "dot end-dot"
}, null, -1);
const _hoisted_33 = {
  class: "address"
};
const _hoisted_34 = {
  key: 1,
  class: "card order-bill"
};
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", null, "无可用优惠券", -1);
const _hoisted_36 = {
  key: 0,
  class: "payment-method"
};
const _hoisted_37 = {
  key: 1,
  class: "payment-method"
};
const _hoisted_38 = {
  key: 1,
  class: "amount"
};
const _hoisted_39 = {
  key: 0,
  style: {
    "margin-left": "5px",
    "display": "inline-block",
    "background": "orangered",
    "color": "#ffffff",
    "border-radius": "4px",
    "font-size": "14px",
    "padding": "3px 6px"
  }
};
const _hoisted_40 = {
  key: 1,
  style: {
    "margin-left": "5px",
    "display": "inline-block",
    "background": "orangered",
    "color": "#ffffff",
    "border-radius": "4px",
    "font-size": "14px",
    "padding": "3px 6px"
  }
};
const _hoisted_41 = {
  class: "payment-methods"
};
const _hoisted_42 = {
  class: "wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _$setup$orderDetailDa2, _$setup$orderDetailDa3, _$setup$orderDetailDa4;
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_cell_group = _resolveComponent("van-cell-group");
  const _component_van_button = _resolveComponent("van-button");
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  const _component_van_action_sheet = _resolveComponent("van-action-sheet");
  const _component_van_loading = _resolveComponent("van-loading");
  const _component_van_overlay = _resolveComponent("van-overlay");
  const _directive_height_animate = _resolveDirective("height-animate");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
    class: "button back-button",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.goBack && $options.goBack(...args))
  }, [_createVNode(_component_van_icon, {
    name: "arrow-left",
    color: "#333"
  })]), _createElementVNode("div", _hoisted_4, [$setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createTextVNode(" 目的地已到达，实际行驶 "), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatSeconds($options.CommonUtil.toDate($setup.orderDetailData.arrive_destination_time, 'YYYY-MM-DD HH:mm:ss').getTime() / 1000 - $options.CommonUtil.toDate($setup.orderDetailData.departure_destination_time, 'YYYY-MM-DD HH:mm:ss').getTime() / 1000)), 1)])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, [false ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_van_icon, {
    class: "security",
    name: require('@/assets/icon/security.svg')
  }, null, 8, ["name"])])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "button right-button",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.getCurrentPosition && $options.getCurrentPosition(...args))
  }, [_createVNode(_component_van_icon, {
    name: "service-o",
    color: "#555"
  })])) : _createCommentVNode("", true)])]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [$setup.orderDetailData && $setup.orderDetailData.service_car_type === 'ORDER_CAR_TYPE_ONLINE_TAXI' ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 0,
    size: "large",
    type: "danger"
  }, {
    default: _withCtx(() => [_createTextVNode(" 新出租 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.service_car_type === 'ORDER_CAR_TYPE_NORMAL_TAXI' ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 1,
    color: "#ff9500",
    size: "large",
    type: "warning"
  }, {
    default: _withCtx(() => [_createTextVNode(" 出租车 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 2
  }, [_createTextVNode(" 请支付行程费用 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_RATING' || $setup.orderDetailData.order_state === 'ORDER_STATUS_COMPLETED') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 3
  }, [_createTextVNode(" 订单已完成 ")], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_15, [$setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createTextVNode(" 行程已于"), _createElementVNode("strong", null, _toDisplayString($setup.orderDetailData.arrive_destination_time), 1), _createTextVNode("结束，实际距离"), _createElementVNode("strong", null, _toDisplayString($setup.kilometer), 1), _createTextVNode("公里，行驶时长"), _createElementVNode("strong", null, _toDisplayString($options.CommonUtil.formatSeconds($options.CommonUtil.toDate($setup.orderDetailData.arrive_destination_time, 'YYYY-MM-DD HH:mm:ss').getTime() / 1000 - $options.CommonUtil.toDate($setup.orderDetailData.departure_destination_time, 'YYYY-MM-DD HH:mm:ss').getTime() / 1000)), 1), _createTextVNode("，请及时支付行程费用。 ")], 64)) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_RATING' || $setup.orderDetailData.order_state === 'ORDER_STATUS_COMPLETED') ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createTextVNode(" 订单已经完成，感谢使用" + _toDisplayString($options.Config.appName) + "，欢迎再次使用。 ", 1)], 64)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_16, [$setup.orderDetailData && $setup.orderDetailData.functionType === 1 ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 0,
    size: "medium",
    type: "primary",
    plain: "",
    round: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "underway-o"
    }), _createTextVNode(" 打表来接 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.replacePassengerPhone && $setup.orderDetailData.replacePassengerPhone.length > 0 ? (_openBlock(), _createBlock(_component_van_tag, {
    key: 1,
    size: "medium",
    type: "primary",
    plain: "",
    round: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "phone-o"
    }), _createTextVNode(" 代人叫车 ")]),
    _: 1
  })) : _createCommentVNode("", true)])])]), _createElementVNode("div", {
    class: "card-bold vehicle-info",
    style: _normalizeStyle($setup.orderDetailData && $setup.orderDetailData.order_type === 'ORDER_TYPE_VOICE' ? 'border-radius: 0 0 12px 12px;' : '')
  }, [_createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.plate_number : ''), 1), false ? (_openBlock(), _createElementBlock("div", _hoisted_19, "> " + _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.vehicle_brand : '') + " • " + _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.vehicle_color : ''), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.driver_name.substr(0, 1) + '师傅' : ''), 1), $setup.orderDetailData && $setup.orderDetailData.driverQuality ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_van_icon, {
    name: "star"
  }), _createTextVNode(" " + _toDisplayString($setup.orderDetailData.driverQuality === 0 ? 5 : parseFloat($setup.orderDetailData.driverQuality).toFixed(1)) + "分 ", 1)])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_service_count ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.orderDetailData.order_service_count) + "单 ", 1)) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("img", {
    src: require('@/assets/img/vehicle/taxi.png')
  }, null, 8, _hoisted_25), $setup.orderDetailData && $setup.orderDetailData.vehicle_transport_company_name ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString($setup.orderDetailData ? $setup.orderDetailData.vehicle_transport_company_name : ''), 1)) : _createCommentVNode("", true)])], 4), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_hoisted_29, _createElementVNode("div", _hoisted_30, _toDisplayString($setup.orderDetailData.departure_address), 1)]), _createVNode(_component_van_icon, {
    class: "line",
    name: "down"
  }), _createElementVNode("div", _hoisted_31, [_hoisted_32, _createElementVNode("div", _hoisted_33, _toDisplayString($setup.orderDetailData.destination_address), 1)])])) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_ARRIVED_DROP_OFF' || $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' || $setup.orderDetailData.order_state === 'ORDER_STATUS_RATING' || $setup.orderDetailData.order_state === 'ORDER_STATUS_COMPLETED') ? (_openBlock(), _createElementBlock("div", _hoisted_34, [_createVNode(_component_van_cell_group, null, {
    default: _withCtx(() => [false ? (_openBlock(), _createBlock(_component_van_cell, {
      key: 0,
      title: "行程费用",
      "is-link": false
    }, {
      value: _withCtx(() => {
        var _$setup$orderDetailDa;
        return [_createTextVNode(_toDisplayString((_$setup$orderDetailDa = $setup.orderDetailData.transportation_cost) === null || _$setup$orderDetailDa === void 0 ? void 0 : _$setup$orderDetailDa.toFixed(2)) + " 元 ", 1)];
      }),
      _: 1
    })) : _createCommentVNode("", true), false ? (_openBlock(), _createBlock(_component_van_cell, {
      key: 1,
      title: "优惠券"
    }, {
      value: _withCtx(() => [_hoisted_35]),
      _: 1
    })) : _createCommentVNode("", true)]),
    _: 1
  }), false ? (_openBlock(), _createBlock(_component_van_cell, {
    key: 0,
    "is-link": $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT',
    title: "支付方式",
    onClick: $options.clickShowPaymentMethod
  }, {
    value: _withCtx(() => [$setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' || $setup.orderDetailData.order_state === 'ORDER_STATUS_RATING') ? (_openBlock(), _createElementBlock("div", _hoisted_36, [$setup.paymentMethodType === 'cash' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 0
    }, [_createVNode(_component_van_icon, {
      name: "gold-coin",
      color: "#009393",
      size: "18px"
    }), _createTextVNode(" 现金支付 ")], 64)) : _createCommentVNode("", true), $setup.paymentMethodType === 'wechat' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 1
    }, [_createVNode(_component_van_icon, {
      name: "wechat-pay",
      color: "#22AC38",
      size: "18px"
    }), _createTextVNode(" 微信支付 ")], 64)) : _createCommentVNode("", true), $setup.paymentMethodType === 'alipay' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 2
    }, [_createVNode(_component_van_icon, {
      name: "alipay",
      color: "#1677FF",
      size: "18px"
    }), _createTextVNode(" 支付宝 ")], 64)) : _createCommentVNode("", true), $setup.paymentMethodType === 'wallet' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 3
    }, [_createVNode(_component_van_icon, {
      name: require('@/assets/icon/wallet.png'),
      color: "#22AC38",
      size: "18px"
    }, null, 8, ["name"]), _createTextVNode(" 钱包支付 ")], 64)) : _createCommentVNode("", true), $setup.paymentMethodType === 'bankcard' ? (_openBlock(), _createElementBlock(_Fragment, {
      key: 4
    }, [_createVNode(_component_van_icon, {
      name: "card",
      color: "#1677FF",
      size: "18px"
    }), _createTextVNode(" 银行卡 ")], 64)) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.transportation_cost === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createVNode(_component_van_icon, {
      name: require('@/assets/icon/wallet.png'),
      color: "#22AC38",
      size: "18px"
    }, null, 8, ["name"]), _createTextVNode(" 钱包支付 ")])) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["is-link", "onClick"])) : _createCommentVNode("", true), $setup.orderDetailData.transportation_cost ? (_openBlock(), _createElementBlock("div", _hoisted_38, [$setup.orderDetailData.promotionsData ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_createElementVNode("strong", null, _toDisplayString(($setup.orderDetailData.transportation_receivable_amount + $setup.orderDetailData.transportation_tolls).toFixed(2)), 1), _createTextVNode("元 "), ((_$setup$orderDetailDa2 = $setup.orderDetailData.promotionsData) === null || _$setup$orderDetailDa2 === void 0 ? void 0 : _$setup$orderDetailDa2.total_price_discount) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_39, _toDisplayString(((_$setup$orderDetailDa3 = $setup.orderDetailData.promotionsData) === null || _$setup$orderDetailDa3 === void 0 ? void 0 : _$setup$orderDetailDa3.total_price_discount) * 10) + "折 ", 1)) : (_openBlock(), _createElementBlock("div", _hoisted_40, " 活动价 "))], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
    key: 1
  }, [_createElementVNode("strong", null, _toDisplayString((_$setup$orderDetailDa4 = $setup.orderDetailData.transportation_cost) === null || _$setup$orderDetailDa4 === void 0 ? void 0 : _$setup$orderDetailDa4.toFixed(2)), 1), _createTextVNode("元 ")], 64))])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), $setup.orderDetailData && $setup.orderDetailData.order_state === 'ORDER_STATUS_WAIT_PAYMENT' ? (_openBlock(), _createBlock(_component_van_button, {
    key: 2,
    type: "primary",
    class: "submit-button"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "gold-coin-o"
    }), _createTextVNode("  请向司机支付费用 ")]),
    _: 1
  })) : _createCommentVNode("", true), $setup.orderDetailData && ($setup.orderDetailData.order_state === 'ORDER_STATUS_COMPLETED' || $setup.orderDetailData.order_state === 'ORDER_STATUS_RATING') ? (_openBlock(), _createBlock(_component_van_button, {
    key: 3,
    type: "default",
    class: "finish-button",
    onClick: $options.finish
  }, {
    default: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "passed"
    }), _createTextVNode("  完成订单 ")]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true)])])), [[_directive_height_animate]])]), _createVNode(_component_van_action_sheet, {
    show: $setup.showPaymentMethod,
    "onUpdate:show": _cache[7] || (_cache[7] = $event => $setup.showPaymentMethod = $event),
    "cancel-text": "取消",
    description: "请选择支付方式",
    "close-on-click-action": ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createVNode(_component_van_radio_group, {
      modelValue: $setup.paymentMethodType,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $setup.paymentMethodType = $event)
    }, {
      default: _withCtx(() => [_createElementVNode("div", {
        class: "payment-method-item",
        onClick: _cache[2] || (_cache[2] = $event => {
          $setup.paymentMethodType = 'wechat';
          $setup.showPaymentMethod = false;
        })
      }, [_createVNode(_component_van_icon, {
        name: "wechat-pay",
        color: "#22AC38",
        size: "20px"
      }), _createTextVNode(" 微信支付 "), _createVNode(_component_van_radio, {
        name: "wechat",
        "checked-color": "#ff9500"
      }, {
        default: _withCtx(() => [_createTextVNode(" ")]),
        _: 1
      })]), false ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "payment-method-item",
        onClick: _cache[3] || (_cache[3] = $event => {
          $setup.paymentMethodType = 'alipay';
          $setup.showPaymentMethod = false;
        })
      }, [_createVNode(_component_van_icon, {
        name: "alipay",
        color: "#1677FF",
        size: "20px"
      }), _createTextVNode(" 支付宝 "), _createVNode(_component_van_radio, {
        name: "alipay",
        "checked-color": "#ff9500"
      }, {
        default: _withCtx(() => [_createTextVNode(" ")]),
        _: 1
      })])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "payment-method-item",
        onClick: _cache[4] || (_cache[4] = $event => {
          $setup.paymentMethodType = 'wallet';
          $setup.showPaymentMethod = false;
        })
      }, [_createVNode(_component_van_icon, {
        name: require('@/assets/icon/wallet.png'),
        color: "#1677FF",
        size: "20px"
      }, null, 8, ["name"]), _createTextVNode(" 我的钱包 "), _createVNode(_component_van_radio, {
        name: "wallet",
        "checked-color": "#ff9500"
      }, {
        default: _withCtx(() => [_createTextVNode(" ")]),
        _: 1
      })])) : _createCommentVNode("", true), false ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "payment-method-item",
        onClick: _cache[5] || (_cache[5] = $event => {
          $setup.paymentMethodType = 'bankcard';
          $setup.showPaymentMethod = false;
        })
      }, [_createVNode(_component_van_icon, {
        name: "card",
        color: "#1677FF",
        size: "20px"
      }), _createTextVNode(" 银行卡 "), _createVNode(_component_van_radio, {
        name: "bankcard",
        "checked-color": "#ff9500"
      }, {
        default: _withCtx(() => [_createTextVNode(" ")]),
        _: 1
      })])) : _createCommentVNode("", true)]),
      _: 1
    }, 8, ["modelValue"])])]),
    _: 1
  }, 8, ["show"]), _createVNode(_component_van_overlay, {
    "z-index": "999",
    show: false
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_42, [_createElementVNode("div", {
      class: "block",
      onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"]))
    }, [_createVNode(_component_van_loading, {
      size: "36px",
      color: "#1989fa",
      "text-size": "14px",
      vertical: ""
    }, {
      default: _withCtx(() => [_createTextVNode("正在准备支付...")]),
      _: 1
    })])])]),
    _: 1
  })]);
}